<template>
  <div>
    <!--
    Logged in
    <span v-if="loggedIn">Yes</span>
    <span v-else>No</span>
    -->
    <div>
      <b-nav-item
        id="signout"
        @click="signout"
        v-if="loggedIn"
        variant="warning"
      >
        Sign out
      </b-nav-item>
    </div>
  </div>
</template>

<script>
import * as firebase from 'firebase/app';
import 'firebase/auth';

export default {
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.loggedIn = true;
      } else {
        this.loggedIn = false;
      }
    });
  },
  data() {
    return {
      loggedIn: false,
    };
  },
  methods: {
    async signout() {
      try {
        await firebase.auth().signOut();
        // const data = await firebase.auth().signOut();
        //console.log(data);
        this.$router.replace({ name: 'login' });
      } catch (err) {
        //console.log(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
